/* eslint-disable react/require-default-props */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/prop-types */
/* eslint-disable max-len */
import { CONTEXT_MENU_MC_HISTORY } from 'Constants/consults';
import { WEBCHAT } from 'Constants/normalize-module';
import { TAB_DOCTOR, TAB_PATIENT } from 'Constants/webchat';
import { updateEntities } from 'Redux/modules/entities/actions';
import * as Actions from 'Redux/modules/webChat/actions';
import { ConfigProvider, Flex, Splitter } from 'antd';
import classnames from 'classnames';
import { any, bool, func, number, shape } from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import { Segment } from 'semantic-ui-react';

import { bubblesAdd, setCurrentActiveTab } from '../../../../redux/modules/webChat/commons/actions';
import { messageMarkAsRead } from '../../../../redux/modules/webChat/messages/actions';

import MessageBodyWrapper from './MessageBody/MessageBodyWrapper';
import MessagesHeader from './MessageHeader/MessageHeader';
import MessageHome from './MessageHome';
import styles from './Messages.less';
import TextComposer from './TextComposer/TextComposer';
import UpdatingState from './UpdatingState';

class Messages extends Component {
  constructor() {
    super();
    this.state = {
      // activeTab: TAB_PATIENT,
      replyMessageState: null,
    };
  }

  componentDidUpdate(prevProps) {
    const { conversationActiveId } = this.props;
    if (prevProps.conversationActiveId !== conversationActiveId && conversationActiveId !== -1) {
      this.setActiveTab(TAB_PATIENT);
    }
  }

  setActiveTab = activeTab => {
    const { handleChangeTab, conversationActive } = this.props;
    handleChangeTab(activeTab, conversationActive?.id);
  };

  onChangeTab = () => {
    const { conversationActive, doctor, readMessageFunc, updateEntitiesFunc } = this.props;
    const {
      latestConsult: { consultType, id, doctorConversationId },
    } = conversationActive;
    const activeTab = this.props?.currentActiveTab?.tab;
    const state = {
      action: 'read',
      user: doctor?.data?.userUuid,
      metadata: {
        consultId: id,
        conversationId: activeTab === TAB_PATIENT ? doctorConversationId : id,
        consultType,
      },
    };
    // const { activeTab } = this.state;
    if (activeTab === TAB_PATIENT) {
      this.setActiveTab(TAB_DOCTOR);
      const conversationData = {
        ...conversationActive,
      };
      conversationData.latestConsult.doctorConversation.participant.unreadCount = 0;
      readMessageFunc(state);
      updateEntitiesFunc(WEBCHAT, 'conversation', doctorConversationId, conversationData);

      // close mc history context menu when open doctor tab
      const { contextMenu, onCloseContextMenu } = this.props;
      if (contextMenu.type.includes(CONTEXT_MENU_MC_HISTORY)) {
        onCloseContextMenu();
      }
    } else {
      this.setActiveTab(TAB_PATIENT);
      const conversationData = {
        ...conversationActive,
      };
      conversationData.participant.unreadCount = 0;
      readMessageFunc(state);
      updateEntitiesFunc(WEBCHAT, 'conversation', id, conversationData);
    }
    this.setState({ replyMessageState: null });
  };

  render() {
    const {
      sendMessage,
      changeContextMenu,
      conversationActive,
      sendTypingEvent,
      appointment,
      contextMenu,
      openMedicalCertificate,
      conversationActiveId,
      doctor,
      openFinishConsult,
      isMinimize,
      addBubbleChat,
      openPrescriptionModal,
      openReferralMemo,
      openPOS,
      openMemoRandum,
      onCloseContextMenu,
      consults,
      consult,
      currentActiveTab,
      children,
      profile,
    } = this.props;
    const { pendingConsultActive } = consults;
    const profileId = profile?.id;

    // display updating state when conversation is updating by this doctor
    const consultIsUpdating =
      conversationActive?.isUpdating && conversationActive?.updatedBy === profileId;
    const clinics = conversationActive?.latestConsult?.clinics || [];
    const clinicName = clinics.find(item => item.doctorId === profileId)?.clinicName || '';

    if (conversationActiveId === -1 && !isMinimize && pendingConsultActive === -1) {
      const {
        conversations: {
          status: { loadList },
        },
      } = this.props;
      const isLoadingConsultGroup = loadList === 0;
      return <MessageHome user={appointment} loading={isLoadingConsultGroup} />;
    }

    const activeTab =
      currentActiveTab?.tab && currentActiveTab?.groupId === conversationActive?.id
        ? currentActiveTab?.tab
        : TAB_PATIENT;
    const {
      search: { consultActiveSearch },
      readMessage,
    } = this.props;

    const { replyMessageState } = this.state;
    const classNames = classnames({ [styles.miniWrap]: isMinimize });

    return (
      <Segment.Group className={`messages ${classNames}`}>
        {(conversationActive || consultActiveSearch || pendingConsultActive !== -1) && (
          <MessagesHeader
            changeContextMenu={changeContextMenu}
            conversationActive={conversationActive || consultActiveSearch}
            contextMenu={contextMenu}
            doctor={doctor.data}
            openFinishConsult={openFinishConsult}
            isMinimize={isMinimize}
            onClickBubble={addBubbleChat}
            conversationActiveId={conversationActiveId}
            openPrescriptionModal={openPrescriptionModal}
            openReferralMemo={openReferralMemo}
            openMemoRandum={openMemoRandum}
            openPOS={openPOS}
            openMedicalCertificate={openMedicalCertificate}
            onCloseContextMenu={onCloseContextMenu}
            activeTab={activeTab}
            pendingConsultActive={pendingConsultActive}
          />
        )}
        <ConfigProvider
          theme={{
            components: {
              Splitter: {
                splitterSize: 0,
                splitBarSize: 0,
                splitBarDraggableSize: 0,
              },
            },
          }}>
          <Splitter
            style={{
              padding: 0,
              height: 'calc(100% - 64px)',
              justifyContent: 'space-between',
              background: 'white',
            }}>
            <Splitter.Panel defaultSize="50%" min={360} style={{ padding: 0 }}>
              <Flex vertical style={{ height: '100%' }} id="message-body-wrap">
                {consultIsUpdating ? (
                  <UpdatingState clinicName={clinicName} />
                ) : (
                  <>
                    {(conversationActive || consultActiveSearch || pendingConsultActive !== -1) && (
                      <MessageBodyWrapper
                        openMedicalCertificate={openMedicalCertificate}
                        conversationActiveId={conversationActiveId}
                        conversationActive={conversationActive || consultActiveSearch}
                        pendingConsultActive={pendingConsultActive}
                        onChangeTab={this.onChangeTab}
                        activeTab={activeTab}
                        doctor={doctor.data}
                        isMinimize={isMinimize}
                        onSetReply={message => {
                          this.setState({ replyMessageState: message });
                        }}
                        changeContextMenu={changeContextMenu}
                      />
                    )}
                    {(conversationActive || consultActiveSearch) && (
                      <TextComposer
                        consult={consult}
                        conversationActive={conversationActive || consultActiveSearch}
                        sendMessage={sendMessage}
                        sendTypingEvent={sendTypingEvent}
                        doctor={doctor.data}
                        activeTab={activeTab}
                        isMinimize={isMinimize}
                        readMessage={readMessage}
                        replyMessageState={replyMessageState}
                        clearReplyMessage={() => {
                          this.setState({ replyMessageState: null });
                        }}
                      />
                    )}
                  </>
                )}
              </Flex>
            </Splitter.Panel>
            <Splitter.Panel
              style={{
                overflow: 'unset',
                padding: 0,
                position: 'relative',
                transition: '0.1s linear',
              }}
              size={children ? undefined : '0'}
              min={360}>
              {children ?? ''}
            </Splitter.Panel>
          </Splitter>
        </ConfigProvider>
      </Segment.Group>
    );
  }
}

Messages.propTypes = {
  conversationActiveId: number,
  sendTypingEvent: func,
  conversationActive: shape({}),
  sendMessage: func.isRequired,
  doctor: shape({}).isRequired,
  consult: any,
  search: shape({}).isRequired,
  appointment: shape({}).isRequired,
  contextMenu: shape({}).isRequired,
  changeContextMenu: func.isRequired,
  openFinishConsult: func.isRequired,
  addBubbleChat: func.isRequired,
  readMessageFunc: func.isRequired,
  updateEntitiesFunc: func.isRequired,
  conversations: shape({}).isRequired,
  openMedicalCertificate: func.isRequired,
  openPrescriptionModal: func.isRequired,
  openReferralMemo: func.isRequired,
  openPOS: func.isRequired,
  openMemoRandum: func.isRequired,
  isMinimize: bool,
  profile: shape({}).isRequired,
};

Messages.defaultProps = {
  conversationActiveId: -1,
  conversationActive: null,
  sendTypingEvent: () => undefined,
  isMinimize: false,
};

const mapStateToProps = state => ({
  doctor: state.webChat.doctor,
  search: state.search.teleconsult,
  contextMenu: state.webChat.contextMenu,
  consults: state.webChat.consults,
  appointment: state.auth.data,
  conversationActiveId: state.webChat.conversationActive,
  messages: state.entities.webChat.messages,
  conversations: state.webChat.conversation,
  currentActiveTab: state.webChat.commons.activeTab,
  profile: state.doctors.profile,
});
const mapDispatchToProps = {
  addBubbleChat: bubblesAdd,
  handleChangeTab: setCurrentActiveTab,
  setJumpMessage: Actions.setJumpMessage,
  readMessageFunc: messageMarkAsRead,
  updateEntitiesFunc: updateEntities,
};

export default connect(mapStateToProps, mapDispatchToProps)(Messages);
